import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'

import { TranslateService } from '@ngx-translate/core'

import { ENVIRONMENT } from '../tokens/environment.token'

/**
 * Sends the language the app renders in (site pin included, since the pin
 * drives TranslateService) as Accept-Language on Yoshu API requests, so list
 * and picker payloads carry record translations for the same locale as the
 * page instead of the profile language.
 */
export const localeInterceptor: HttpInterceptorFn = (req, next) => {
  const env = inject(ENVIRONMENT)
  if (!req.url.startsWith(env.apiUrl) || req.headers.has('Accept-Language')) {
    return next(req)
  }
  const translate = inject(TranslateService)
  const lang = translate.currentLang || translate.defaultLang
  if (!lang) {
    return next(req)
  }
  return next(req.clone({ setHeaders: { 'Accept-Language': lang } }))
}
